module.exports = __webpack_public_path__ + "static/media/group-12-progress.c7494b57.jpg";